<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="医疗记录"
      id-key="MedicalId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="reset"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermId">
              <el-select
                v-model="data.TermId"
                size="mini"
                @change="termChange"
                :style="isMB?'width:200px;':'width:185px;'"
              >
                <el-option
                  v-for="item in termList"
                  :key="item.TermId"
                  :value="item.TermId"
                  :label="item.TermName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名" prop="StudentId">
              <el-input
                size="mini"
                v-model="data.FullName"
                @focus="onSTCDialog"
                readonly
                placeholder="点击选择"
                :style="isMB?'width:200px;':''"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="医疗日期" prop="MedicalDate">
              <el-date-picker
                size="mini"
                v-model="data.MedicalDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                :style="isMB?'width:200px;':'width:184px;'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="医生" prop="Doctor">
              <el-input
                size="mini"
                v-model="data.Doctor"
                placeholder="请填写医生"
                :style="isMB?'width:200px;':''"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始节次" prop="StartSectionId">
              <el-select v-model="data.StartSectionId" size="mini" :style="isMB?'width:200px;':''">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="结束节次" prop="EndSectionId">
              <el-select v-model="data.EndSectionId" size="mini" :style="isMB?'width:200px;':''">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:24">
            <el-form-item label="内容" prop="Content">
              <el-input
                size="mini"
                v-model="data.Content"
                placeholder="请填写内容"
                :style="isMB?'width:200px;':''"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:24">
            <el-form-item label="备注" prop="Remark">
              <el-input
                size="mini"
                v-model="data.Remark"
                placeholder="请填写备注"
                :style="isMB?'width:200px;':''"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <stc-dialog ref="stcDialog" in-dialog selectable :multiple="false" @select="setSTC" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import stcDialog from "@/components/st/sc/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stcDialog,
  },
  data() {
    return {
      data: {
        MedicalId: 0,
        ClassId: null,
        StudentId: null,
        FullName: "",
        MedicalDate: "",
        TermId: null,
        Content: "",
        Remark: "",
        Doctor: "",
        GradeId: null,
        StartSectionId: null,
        EndSectionId: null,
      },
      api: require("@/api/st/medical").default,
      sectionApi: require("@/api/ed/section").default,
      termApi,
      isMB: this.$store.state.isMB,
      termList: [],
      TeacherId: 0,
      sectionList: [],
      rules: {
        TermId: [{ required: true, message: "请选择学期" }],
        StudentId: [{ required: true, message: "请选择学生" }],
        MedicalDate: [{ required: true, message: "请选择医疗日期" }],
        StartSectionId: [{ required: true, message: "请选择开始节次" }],
        EndSectionId: [{ required: true, message: "请选择结束节次" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.data.Doctor = loginInfo.UserName;
      this.data.TermId =
        loginInfo.TermId > 0
          ? loginInfo.TermId
          : Number(sessionStorage.getItem("termId"));
      this.getOption();
      this.data.MedicalDate = this.$commonJs.getToday();
    },
    onEditOpened(row) {
      this.getOption();
      this.getSection(row.TermId, row.GradeId);
    },
    getOption() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.data.TeacherId = loginInfo.TeacherId;
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        res.Data.forEach((item) => {
          if (this.data.TermId == item.TermId) {
            this.startLimit = item.StartTime;
            this.endLimit = item.EndTime;
          }
        });
      });
    },
    getSection(TermId, GradeId, setSection = false) {
      if (TermId && GradeId) {
        this.sectionApi.list({ TermId, GradeId }).then((res) => {
          this.sectionList = res.Data;

          if (setSection) {
            var now = this.$commonJs.toDatetimeString(new Date());
            // var c = JSON.parse(JSON.stringify(this.sectionList));
            // console.log("节次列表", c, now);
            var section = this.sectionList.find(
              (x) => x.StartTime2 <= now && now <= x.EndTime2
            );
            // console.log("当前节次", section);
            if (section) {
              this.data.StartSectionId = section.SectionId;
              this.data.EndSectionId = section.SectionId;
            }
          }
        });
      }
    },
    onBeforeSave() {
      var medical_date = this.$commonJs.toDateString(
        new Date(this.data.MedicalDate)
      );
      var start_date = this.$commonJs.toDateString(new Date(this.startLimit));
      var end_date = this.$commonJs.toDateString(new Date(this.endLimit));
      if (medical_date < start_date || medical_date > end_date) {
        this.$message.error("医疗日期不在所选学期范围内");
        return false;
      }
      let index1 = null;
      let index2 = null;
      this.sectionList.forEach((e, index) => {
        if (this.data.StartSectionId == e.SectionId) {
          index1 = index;
        }
        if (this.data.EndSectionId == e.SectionId) {
          index2 = index;
        }
      });
      if (index1 > index2) {
        this.$message.error("开始节次不得在结束节次之后");
        return false;
      }
    },
    onSTCDialog() {
      this.$refs.stcDialog.open().then((that) => {
        that.getDataWithClass(this.data.TermId, this.data.TeacherId);
      });
    },
    termChange(e) {
      this.termList.forEach((item) => {
        if (e == item.TermId) {
          this.startLimit = item.StartTime;
          this.endLimit = item.EndTime;
          this.data.StudentId = null;
          this.data.FullName = null;
          this.data.StartSectionId = null;
          this.data.EndSectionId = null;
          this.getSection(e, this.data.GradeId);
        }
      });
    },
    setSTC(stc) {
      console.log("set");
      this.data.StudentId = stc.StudentId;
      this.data.FullName = stc.FullName;
      this.data.ClassId = stc.ClassId;
      if (stc.GradeId != this.data.GradeId) {
        this.data.GradeId = stc.GradeId;
        this.data.StartSectionId = null;
        this.data.EndSectionId = null;
        this.getSection(this.data.TermId, stc.GradeId, true);
      }
    },
    reset() {
      // this.data.TermId = null
      this.data.sectionList = [];
    },
  },
};
</script>
<style lang="scss">
</style>